module.exports = __webpack_public_path__ + "static/z_tall_st_george-21c90736ccb5f9b94125b7c3b283914e.jpg";